import { canUsePermission } from "../../../lib/auth";
import { useCurrentAuthUser } from "../../auth";
import { ITINERARY_PERMISSIONS, ItineraryMySharesFeaturePage } from "..";

/** 我的分享页面入口，员工切换时重建个人界面状态。 */
export function ItineraryMySharesPage() {
  const auth = useCurrentAuthUser();
  if (!auth.isSuccess || !canUsePermission(auth.data, ITINERARY_PERMISSIONS.mySharesAccess)) return null;
  return <ItineraryMySharesFeaturePage key={auth.data.id} ownerId={auth.data.id}
    canRevoke={canUsePermission(auth.data, ITINERARY_PERMISSIONS.share)} />;
}
